import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewChecked,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import {
  AlertController,
  ModalController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Observable, debounceTime, from } from 'rxjs';
import { mergeMap, first } from 'rxjs/operators';
import { Stylist } from '../../models/stylist/stylist.model';
import { Client } from '../../models/client/client.model';
import { ServiceCategory } from '../../models/service-category/service-category.model';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { UserService } from '../../services/user.service';
import {
  BulkEmailService,
  BulkEmailRecipient,
} from '../../services/bulk-email.service';
import { ServiceCategoryService } from '../../services/service-category.service';
import { Utilities } from '../../utilities/utilities';

import { List } from 'immutable';
import {
  AwsBucketManagerProvider,
  S3DirName,
} from '../../services/aws-bucket-manager.service';

import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
const DirectionAttribute = Quill.import('attributors/attribute/direction');
Quill.register(DirectionAttribute, true);
const AlignClass = Quill.import('attributors/class/align');
Quill.register(AlignClass, true);
const BackgroundClass = Quill.import('attributors/class/background');
Quill.register(BackgroundClass, true);
const ColorClass = Quill.import('attributors/class/color');
Quill.register(ColorClass, true);
const DirectionClass = Quill.import('attributors/class/direction');
Quill.register(DirectionClass, true);
const FontClass = Quill.import('attributors/class/font');
Quill.register(FontClass, true);
const SizeClass = Quill.import('attributors/class/size');
Quill.register(SizeClass, true);
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);
const BackgroundStyle = Quill.import('attributors/style/background');
Quill.register(BackgroundStyle, true);
const ColorStyle = Quill.import('attributors/style/color');
Quill.register(ColorStyle, true);
const DirectionStyle = Quill.import('attributors/style/direction');
Quill.register(DirectionStyle, true);
const FontStyle = Quill.import('attributors/style/font');
Quill.register(FontStyle, true);
const SizeStyle = Quill.import('attributors/style/size');
Quill.register(SizeStyle, true);

@Component({
  selector: 'smr-marketing-composer',
  templateUrl: './marketing-composer.component.html',
  styleUrls: ['./marketing-composer.component.scss'],
})
export class MarketingComposerComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean = true;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public stylistID: number;

  public readOnlyStylistPicker: boolean;

  public submitAttempt: boolean;

  public currency: string;

  public marketingComposerForm: UntypedFormGroup;

  public emailSubject: FormControl;

  public emailBody: FormControl;

  public filterType: FormControl;

  public appointmentBeforeAfterOption: FormControl;

  public appointmentStartDateOption: FormControl;

  public appointmentEndDateOption: FormControl;

  public spentRangeOption: FormControl;

  public spentStartPrice: FormControl;

  public spentEndPrice: FormControl;

  public birthdayRangeOption: FormControl;

  public birthdayStartDate: FormControl;

  public birthdayEndDate: FormControl;

  public serviceSelector: FormControl;

  public serviceCategories: List<ServiceCategory>;

  public numberOfRecipients: number;

  public loadingRecipients: boolean;
  public dateTimeMaxRange: string;

  private emailBodyLocalStorageKey = 'email.body';
  private emailSubjectLocalStorageKey = 'email.title';

  public dateError: any = { isError: false, errorMessage: '' };

  // public quillConfigModules : QuillModule= {
  //   toolbar: [
  //     { font: [] },
  //     //{ header: [] },
  //     { header: [1, 2, 3, false] },
  //     'divider',
  //     'bold',
  //     'italic',
  //     'underline',
  //     'strike',
  //     'divider',
  //     { list: 'ordered' },
  //     { list: 'bullet' },
  //     'divider',
  //     { indent: '-1' },
  //     { indent: '+1' },
  //     { align: [] },
  //     'divider',
  //     { color: [] },
  //     { background: [] },
  //     //'clean',
  //     'divider',
  //     'link',
  //     'image',
  //   ],
  // };
  public quillConfigModules : QuillModule= {
    customOptions: {
      size:[]
    },
    toolbar: {
      container:[
        [{ font: [] },
        //{ header: [] },
        { header: [1, 2, 3, false] }],
        // ['divider'],
        ['bold',
        'italic',
        'underline',
        'strike'],
        // ['divider'],
        [{ list: 'ordered' },
        { list: 'bullet' }],
        // ['divider'],
        [{ indent: '-1' },
        { indent: '+1' },
        { align: [] }],
        // ['divider'],
        [{ color: [] },
        { background: [] }],
        //'clean',
        // ['divider'],
        ['link',
        'image'],
      ]
    }
  }


  public excludeClients: List<Client> = List([]);

  public recipients;

  public selectedRecipients;

  constructor(
    private loadingCtrl: LoadingController,
    private alertController: AlertController,
    private toastController: ToastController,
    private userService: UserService,
    private bulkEmailService: BulkEmailService,
    private serviceCategoryService: ServiceCategoryService,
    private modalController: ModalController,
    private formBuilder: UntypedFormBuilder,
    private awsBucketManager: AwsBucketManagerProvider,
    private cdRef: ChangeDetectorRef,
    private readonly alertService: AlertService,
    private readonly toastService: ToastService
  ) {
    this.isLoading = true;
    this.currency = Utilities.decodeHTML(
      this.userService.getSalon()
        ? this.userService.getSalon().getCurrency()
        : ''
    );
    this.serviceCategories = List([]);
    this.numberOfRecipients = 0;
    this.loadingRecipients = false;


    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }

    this.filterType = new FormControl('allclients');
    this.emailSubject = new FormControl('');
    this.emailBody = new FormControl('', Validators.required);

    // extra filter options
    this.appointmentBeforeAfterOption = new FormControl('before');
    this.appointmentStartDateOption = new FormControl(
      new Date().toISOString()
    );
    this.appointmentEndDateOption = new FormControl(
      Utilities.addDays(new Date(), 7).toISOString(),
    );
    this.spentRangeOption = new FormControl('morethan');
    this.spentStartPrice = new FormControl(0);
    this.spentEndPrice = new FormControl(0);

    this.birthdayRangeOption = new FormControl('ison');
    this.birthdayStartDate = new FormControl(
      Utilities.formatDate(new Date(), 'Y-MM-DD')
    );
    this.birthdayEndDate = new FormControl(
      Utilities.formatDate(Utilities.addDays(new Date(), 7), 'Y-MM-DD')
    );
    const today = new Date();
    const maxYear = today.getFullYear() + 5;
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); 
    const day = today.getDate().toString().padStart(2, '0'); 
    this.dateTimeMaxRange = `${maxYear}-${month}-${day}`;

    this.serviceSelector = new FormControl();

    this.marketingComposerForm = this.formBuilder.group({
      filterType: this.filterType,
      emailSubject: this.emailSubject,
      emailBody: this.emailBody,

      // extra options
      appointmentBeforeAfterOption: this.appointmentBeforeAfterOption,
      appointmentStartDateOption: this.appointmentStartDateOption,
      appointmentEndDateOption: this.appointmentEndDateOption,

      spentRangeOption: this.spentRangeOption,
      spentStartPrice: this.spentStartPrice,
      spentEndPrice: this.spentEndPrice,

      birthdayRangeOption: this.birthdayRangeOption,
      birthdayStartDate: this.birthdayStartDate,
      birthdayEndDate: this.birthdayEndDate,

      serviceSelector: this.serviceSelector,
    });

    this.selectedRecipients = new FormControl();
  }

  emailFocus() {
    this.emailSubject.setValidators(Validators.required);
  }

  check(event) {
    console.log(event)
    console.log(this.emailBody.value)
  }

  public ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public ngOnInit() {
    this.refreshNumberOfRecipients();
    this.autoLoadEmailTextFromLocalStorage();
    this.initAutoSave();
  }

  public async ngOnDestroy() {
    if (this.emailSubject.value != '' || this.emailBody.value != '') {
      let alert = await this.alertController.create({
        header: 'Email Marketing',
        message: `Do you want to save your draft email before leaving the page?`,
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              this.clearEmailTextOnLocalStorage();
            },
          },
          {
            text: 'Yes',
            handler: () => {
              this.saveEmailTextOnLocalStorage();
            },
          },
        ],
      });
      return await alert.present();
    }
  }

  private initAutoSave() {
    this.emailSubject.valueChanges.pipe(debounceTime(100)).subscribe((text) => {
      localStorage.setItem(this.emailSubjectLocalStorageKey, text);
    });
    this.emailBody.valueChanges.pipe(debounceTime(100)).subscribe((text) => {
      localStorage.setItem(this.emailBodyLocalStorageKey, text);
    });
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public async onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    this.stylistID = stylist.id;
    this.refreshNumberOfRecipients();
    await this.filterChanged();
  }

  public async onSendPreview() {
    this.submitAttempt = true;

    const editor = document.getElementsByClassName('ql-editor')[0].innerHTML
    this.emailBody.setValue(editor)
    if (!this.marketingComposerForm.valid) {
      return;
    }

    const subject: string = this.emailSubject.value;
    // const body: string = this.emailBody.value;
    const email: string = this.userService.getUser().email;

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.getEmailBody()
      .then((body) => {
        this.bulkEmailService.sendPreview(subject, body, email).subscribe({
          next: () => {
            loader.dismiss().then(async () => {
              const toast = await this.toastController.create({
                message: `A preview email has been sent to ${email}`,
                duration: 3000,
              });
              toast.present().then(() => {
                this.clearEmailTextOnLocalStorage();
              });
            });
          },
          error: (err) => {
            loader.dismiss().then(async () => {
              const alert = await this.alertController.create(
                Utilities.getDefaultErrorMessageConfig()
              );
              alert.present();
            });
          },
        });
      })
      .catch(async () => {
        const alert = await this.alertController.create(
          Utilities.getDefaultErrorMessageConfig()
        );
        alert.present();
      });
  }

  public async onSend() {
    this.submitAttempt = true;
    const editor = document.getElementsByClassName('ql-editor')[0].innerHTML
    this.emailBody.setValue(editor)
    if (!this.marketingComposerForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();
    this.requestBuilder().subscribe({
      next: (response) => {
        loader.dismiss().then(() => {
          this.resetForm();
          this.toastService.presentSimpleToast(`Message has been sent`, 3000);
        });
      },
      error: (e) => {
        loader.dismiss().then(() => {
          this.alertService.presentErrorAlert();
        });
      },
    });
  }

  public resetForm() {
    this.submitAttempt = false;
    this.filterType.setValue('allclients');
    this.emailSubject.setValue('');
    this.emailBody.setValue('');
    this.excludeClients = List([]);
  }

  private getEmailBody() {
    return this.bulkEmailService.extractBase64AndUpload(
      this.emailBody.value,
      "email-marketing"
    );
  }

  public requestBuilder(): Observable<List<BulkEmailRecipient>> {
    return from(this.getEmailBody()).pipe(
      mergeMap((emailBody) => {
        switch (this.filterType.value) {
          case 'allclients':
            return this.bulkEmailService.stylistClients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.excludeClients
            );
          case 'appointment':
            return this.bulkEmailService.clientsWhoseAppointments(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.appointmentBeforeAfterOption.value,
              this.appointmentStartDateOption.value,
              this.appointmentEndDateOption.value,
              this.excludeClients
            );
          case 'spent':
            return this.bulkEmailService.clientsWhoSpent(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.spentRangeOption.value,
              parseFloat(this.spentStartPrice.value),
              parseFloat(this.spentEndPrice.value),
              this.excludeClients
            );
          case 'birthday':
            return this.bulkEmailService.clientsWhoseBirthday(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.birthdayRangeOption.value,
              this.birthdayStartDate.value,
              this.birthdayEndDate.value,
              this.excludeClients
            );
          case 'service':
            return this.bulkEmailService.clientsWhoHadService(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.serviceSelector.value,
              this.excludeClients
            );
          default:
            break;
        }
      })
    );
  }

  public recipientsRequestBuilder(): Observable<List<BulkEmailRecipient>> {
    return from(this.getEmailBody()).pipe(
      mergeMap((emailBody) => {
        switch (this.filterType.value) {
          case 'allclients':
            return this.bulkEmailService.stylistClientsRecipients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.excludeClients
            );
          case 'appointment':
            return this.bulkEmailService.clientsWhoseAppointmentsRecipients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.appointmentBeforeAfterOption.value,
              this.appointmentStartDateOption.value,
              this.appointmentEndDateOption.value,
              this.excludeClients
            );
          case 'spent':
            return this.bulkEmailService.clientsWhoSpentRecipients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.spentRangeOption.value,
              parseFloat(this.spentStartPrice.value),
              parseFloat(this.spentEndPrice.value),
              this.excludeClients
            );
          case 'birthday':
            return this.bulkEmailService.clientsWhoseBirthdayRecipients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.birthdayRangeOption.value,
              this.birthdayStartDate.value,
              this.birthdayEndDate.value,
              this.excludeClients
            );
          case 'service':
            return this.bulkEmailService.clientsWhoHadServiceRecipients(
              this.emailSubject.value,
              emailBody,
              this.stylistID,
              this.serviceSelector.value,
              this.excludeClients
            );
          default:
            break;
        }
      })
    );
  }

  public async filterChanged() {
    if (this.filterType.value !== 'service') {
      this.refreshNumberOfRecipients();
      return;
    }
    try {
      if (this.stylistID === 0) {
        this.serviceCategories = await this.serviceCategoryService.getSalonServiceCategories().toPromise();
      } else {
        this.serviceCategories = await this.serviceCategoryService
        .getServiceCategories(this.stylistID,this.userService.getSalon().getId(), true).toPromise();
      
      }
      if (this.serviceCategories.count() !== 0) {
        const serviceCategory = this.serviceCategories.first();
        this.serviceSelector.setValue(
          serviceCategory.serviceDefinitions[0] ? serviceCategory.serviceDefinitions[0].name : undefined
        );
      } 
    } catch (e) {
      throw new Error(e);
    } finally {
      this.refreshNumberOfRecipients();

    }
  }

  public refreshNumberOfRecipients() {
    this.numberOfRecipients = 0;
    this.loadingRecipients = true;
    this.recipientsRequestBuilder().subscribe({
      next: (recipients: List<BulkEmailRecipient>) => {
        this.recipients = recipients.toArray();
        this.selectedRecipients = recipients.toArray();
        this.numberOfRecipients = recipients.count();
        this.loadingRecipients = false;
      },
      error: (e) => {
        this.loadingRecipients = false;
      },
    });
  }

  private clearEmailTextOnLocalStorage() {
    localStorage.setItem(this.emailSubjectLocalStorageKey, '');
    localStorage.setItem(this.emailBodyLocalStorageKey, '');
  }

  private saveEmailTextOnLocalStorage() {
    localStorage.setItem(
      this.emailSubjectLocalStorageKey,
      this.emailSubject.value
    );
    localStorage.setItem(this.emailBodyLocalStorageKey, this.emailBody.value);
  }

  private autoLoadEmailTextFromLocalStorage() {
    const emailSubject = localStorage.getItem(this.emailSubjectLocalStorageKey);

    const emailBody = localStorage.getItem(this.emailBodyLocalStorageKey);

    this.emailSubject.patchValue(!!emailSubject ? emailSubject : '');
    this.emailBody.patchValue(!!emailBody ? emailBody : '');
  }

  public compareTwoDates() {
    this.refreshNumberOfRecipients();
    if (
      new Date(this.birthdayEndDate.value) <
      new Date(this.birthdayStartDate.value)
    ) {
      this.dateError = {
        isError: true,
        errorMessage: "End date can't before start date",
      };
    } else {
      this.dateError = { isError: false, errorMessage: '' };
    }
  }

  public async send() {
    this.submitAttempt = true;

    if (!this.marketingComposerForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();
    from(this.getEmailBody())
      .pipe(
        mergeMap((emailBody) => {
          return this.bulkEmailService.sendToSelectedClients(
            this.emailSubject.value,
            this.stylistID,
            emailBody,
            this.selectedRecipients
          );
        })
      )
      .subscribe({
        next: (response) => {
          loader.dismiss().then(() => {
            this.resetForm();
            this.toastService.presentSimpleToast(`Message has been sent`, 3000);
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.alertService.presentErrorAlert();
          });
        },
      });
  }
}
